import Debug from 'debug';
import { CMIErrorCode, Scorm2004Api } from '../api';

const debug = Debug('scorm-2004');

export class Scorm2004ApiLogDecorator implements Scorm2004Api {

  constructor(private api: Scorm2004Api) {

  }

  public Initialize(param: '') {
    return this.withLogging(() => this.api.Initialize(param), 'Initialize', param);
  }

  public Terminate(param: '') {
    return this.withLogging(() => this.api.Terminate(param), 'Terminate', param);
  }

  public GetValue(element: string): string {
    return this.withLogging(() => this.api.GetValue(element), 'GetValue', element);
  }

  public SetValue(element: string, value: string): string {
    return this.withLogging(() => this.api.SetValue(element, value), 'SetValue', element, value);
  }

  public Commit(param: '') {
    return this.withLogging(() => this.api.Commit(param), 'Commit', param);
  }

  public GetLastError(): CMIErrorCode {
    return this.withLogging(() => this.api.GetLastError(), 'GetLastError');
  }

  public GetErrorString(errorCode: CMIErrorCode): string {
    return this.withLogging(() => this.api.GetErrorString(errorCode), 'GetErrorString', errorCode);
  }
  public GetDiagnostic(errorCode: CMIErrorCode): string {
    return this.withLogging(() => this.api.GetDiagnostic(errorCode), 'GetDiagnostic', errorCode);
  }

  private withLogging<TResult>(func: () => TResult, name: string, ...params: string[]) {

    this.logBegin(name, params);
    const result = func();
    this.logEnd(name, result);

    return result;
  }

  private logBegin(func: string, ...params: any[]) {
    this.log(func, '<-', params.join(', '));
  }

  private logEnd(func: string, result: any) {
    this.log(func, '->', result);
  }

  private log(...text: string[]) {
    debug('', ...text);
    // console.debug(...text);
  }
}

